module.exports = __webpack_public_path__ + "img/logo.b4336276.png";